import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';
import { Chip, Paper, Grid, Button, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField, Divider } from '@material-ui/core';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import HomeIcon from '@material-ui/icons/Home';
import SendIcon from '@material-ui/icons/Send';
import CloseIcon from '@material-ui/icons/Close';

import green from '@material-ui/core/colors/green';

const styles = theme => ({
    layoutRoot: {},
    success: {
        backgroundColor: green[600],
    },
});

class LaporanSaran extends Component {

    state = {
        error: null,
        isLoaded: false,
        namaPengguna: 'Khalid',
        bottom: false,
        ListMenu: null,
        email: null,
        routeParams: {
            peran_id: JSON.parse(localStorage.getItem('user')).peran_id,
            token: localStorage.getItem('jwt_token')
        },
        disableButton: false
    };

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    };

    componentDidMount = () => {
        this.props.setJudul("Laporan & Saran");
    }

    bukaMenuUtama = () => {
        this.setState({ 
            ...this.state, 
            bottom: true
        });
    }

    toggleDrawer = (side, open, option) => () => {
        this.setState({ ...this.state, [side]: open });
    }

    handleChange = (name) => (event) => {
        // alert('tes');
        this.setState({
            ...this.state,
            [name]: event.target.value
        })
    }

    simpanSaran = () => {
        this.props.setLoading('block');

        this.setState({
            ...this.state,
            disableButton: true
        },()=>{
            this.props.setFeedback(this.state).then((result)=>{
                this.props.setLoading('none');
                
                this.setState({
                    ...this.state,
                    disableButton: false,
                    jenis_feedback_id: null,
                    judul: '',
                    keterangan: '',
                    saran: ''
                });

                // this.setState({
                //     jenis_feedback_id: null,
                //     judul: '',
                //     keterangan: '',
                //     saran: ''
                // })
            });
        })

    }

    tutupNotif = () => {
        this.props.setHasilFeedback({success: false});
        
    }

    render()
    {
        const {classes} = this.props;
        // const {bottom, ListMenu} = this.state;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                
                content={
                    <div style={{width: '100%'}} className="konten-utama">
                        
                        <div className="p-16" style={{border: '0px solid #ccc', width: '100%', background: 'url(http://pmp.dikdasmen.kemdikbud.go.id:1745/assets/images/backgrounds/code.jpg)', marginTop: '-1px', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: 59}}>
                            <Grid container spacing={16}>
                                <Grid item xs={12} sm={12} style={{paddingLeft: 10, background: 'rgba(0, 0, 0, .8)'}}>
                                    {/* <h1 style={{fontSize: 25, fontFamily: 'Helvetica', color: 'white'}}>Laporan & Saran</h1> */}
                                    <Typography variant="caption" style={{color: 'white'}}>Kami berusaha keras menyajikan kepada Anda aplikasi PMP yang sempurna, namun selalu ada hal yang bisa lebih disempurnakan. Oleh karena itu, jangan ragu untuk menyampaikannya kepada Kami :)</Typography>
                                </Grid>
                            </Grid>
                        </div>

                        <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                            <Chip
                                icon={<HomeIcon/>}
                                label=""
                                className={this.props.classes.chip}
                                color="primary"
                                style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                onClick={()=>{this.goTolink('/Beranda')}}
                                />
                            <Chip
                                label="> Laporan & Saran"
                                className={this.props.classes.chip}
                                color="secondary"
                                // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                        </div>
                        
                        <Paper className="p-24">
                            {/* <Typography variant="display2" style={{color:'white'}}>
                                Menu ini sedang dalam pengembangan
                            </Typography>
                            <Typography variant="headline" style={{color:'white'}}>
                                Mohon maaf atas ketidaknyamanannya
                            </Typography> */}
                            <FormControl component="fieldset" className={classes.formControl} style={{width: '100%'}}>
                                <FormLabel component="legend">Jenis Laporan dan Saran</FormLabel>
                                <RadioGroup
                                    aria-label="jenis_feedback_id"
                                    name="jenis_feedback_id"
                                    className={classes.group}
                                    value={this.state.jenis_feedback_id}
                                    onChange={this.handleChange('jenis_feedback_id')}
                                >
                                    <FormControlLabel value="1" control={<Radio />} label="Komentar" />
                                    <FormControlLabel value="2" control={<Radio />} label="Pertanyaan" />
                                    <FormControlLabel value="3" control={<Radio />} label="Laporan Galat (Bug/Error)" />
                                    <FormControlLabel value="4" control={<Radio />} label="Permintaan Fitur" />
                                </RadioGroup>
                                <TextField
                                    id="judul"
                                    label="Judul"
                                    className={classes.textField}
                                    value={this.state.judul}
                                    onChange={this.handleChange('judul')}
                                    variant="outlined"
                                    margin="dense"
                                    style={{width: '100%'}}
                                />
                                <TextField
                                    id="keterangan"
                                    label="Keterangan"
                                    className={classes.textField}
                                    value={this.state.keterangan}
                                    onChange={this.handleChange('keterangan')}
                                    variant="outlined"
                                    margin="dense"
                                    multiline
                                    rowsMax="10"
                                    rows="2"
                                    style={{width: '100%'}}
                                />
                                <TextField
                                    id="saran"
                                    label="Saran"
                                    className={classes.textField}
                                    value={this.state.saran}
                                    onChange={this.handleChange('saran')}
                                    variant="outlined"
                                    margin="dense"
                                    multiline
                                    rowsMax="10"
                                    rows="2"
                                    style={{width: '100%'}}
                                />
                                <br/>
                                <Divider/>
                                {this.props.hasil_simpan_feedback.success === true &&
                                <Paper className="p-8" style={{background: '#4CB344', color: 'white'}}>
                                    <Grid container>
                                        <Grid item xs={10} sm={10} style={{paddingTop: 10}}>
                                            Laporan dan Saran Anda berhasil dikirim. Terima kasih atas kerjasamanya!
                                        </Grid>
                                        <Grid item xs={2} sm={2} style={{textAlign:'right'}}>
                                            <Button onClick={this.tutupNotif}>
                                                <CloseIcon/>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                }
                                <br/>
                                <Button color="primary" variant="contained" onClick={this.simpanSaran} disabled={this.state.disableButton}>
                                    <SendIcon/>&nbsp;&nbsp;
                                    Kirim Laporan & Saran
                                </Button>
                                
                            </FormControl>
                        </Paper>
                        
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        tukarPengguna: Actions.tukarPengguna,
        getPeran: Actions.getPeran,
        setFeedback: Actions.setFeedback,
        setLoading: Actions.setLoading,
        setHasilFeedback: Actions.setHasilFeedback,
        setJudul: Actions.setJudul
    }, dispatch);
}

function mapStateToProps({ Pengguna, App }) {

    return {
        pengguna: Pengguna.pengguna,
        hasil_tukar_pengguna: Pengguna.hasil_tukar_pengguna,
        hasil_simpan_feedback: App.hasil_simpan_feedback,
        loading: App.loading,
        peran: Pengguna.peran
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(LaporanSaran)));



// WEBPACK FOOTER //
// ./src/main/content/example/LaporanSaran.js